module.exports = __webpack_public_path__ + "img/shield-star-fill.3d1cf6f0.svg";